import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { renderActionIcon } from "./authorization_functions";
const useStyles = makeStyles((theme) => ({
    formControl: {
        marginLeft: ".5em",
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: 0,
    },
}));

export default function DropDown({selection, selectOption, options}) {
    const classes = useStyles();

    const handleChange = (event) => {
        let value = event.target.value;
        if (value === "Authorize Access") {
            value = 1
        } if (value === "Deny Access") {
            value = -1
        }
         selectOption(value);
    };

    return (
        <FormControl className={classes.formControl}>
            <Select
                value={selection}
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ "aria-label": "Without label" }}
            >
                {options.map((option, index) => <MenuItem key={index} value={option}>{option}</MenuItem>)}
            </Select>
            <FormHelperText>{renderActionIcon(selection)}</FormHelperText>
        </FormControl>
    );
}